import { ThemeScreenProps } from "../types";
import { resolveColor, MOCK_CATEGORIES, MOCK_ITEMS } from "../constants";
import {
  CatScreen,
  TopBar,
  SearchBar,
  ClearCartBtn,
  CatBody,
  CatSidebar,
  CategoryCard,
  CategoryEmoji,
  CategoryLabel,
  CatMainContent,
  SectionTitle,
  ItemsGrid,
  ItemCard,
  ItemImagePlaceholder,
  BestSellerBadge,
  CatItemName,
  CatItemDesc,
  CatItemPrice,
} from "../styles";

function CategoriesScreen({ colors }: ThemeScreenProps) {
  const bg = resolveColor(colors.backgroundColor, "#f5f5f5");
  const sidebarBg = resolveColor(colors.sidebarBackgroundColor, "#ffffff");
  const sidebarBorder = resolveColor(colors.sidebarOutlineColor, "#4CAF50");
  const surfaceBg = resolveColor(colors.surfaceColor, "#ffffff");
  const primaryText = resolveColor(colors.primaryTextColor, "#1a1a1a");
  const secondaryText = resolveColor(colors.secondaryTextColor, "#888888");
  const accent = resolveColor(colors.secondaryColor, "#fd3a69");

  return (
    <CatScreen $bg={bg}>
      <TopBar>
        <SearchBar>
          <span>🔍</span>
          <span>Search for pasta, ice cream, etc...</span>
        </SearchBar>
        <ClearCartBtn $bg={accent}>🗑 Clear Cart</ClearCartBtn>
      </TopBar>

      <CatBody>
        <CatSidebar $bg={sidebarBg}>
          {MOCK_CATEGORIES.map((cat) => (
            <CategoryCard key={cat.id} $selected={cat.selected} $borderColor={sidebarBorder}>
              <CategoryEmoji>{cat.emoji}</CategoryEmoji>
              <CategoryLabel>{cat.label}</CategoryLabel>
            </CategoryCard>
          ))}
        </CatSidebar>

        <CatMainContent>
          <SectionTitle $color={primaryText}>Cups of Pasta</SectionTitle>
          <ItemsGrid>
            {MOCK_ITEMS.map((item) => (
              <ItemCard key={item.id} $bg={surfaceBg}>
                {item.badge && <BestSellerBadge $color={accent}>BEST SELLER</BestSellerBadge>}
                <ItemImagePlaceholder>🍝</ItemImagePlaceholder>
                <CatItemName $color={primaryText}>{item.name}</CatItemName>
                <CatItemDesc $color={secondaryText}>{item.desc}</CatItemDesc>
                <CatItemPrice $color={primaryText}>{item.price}</CatItemPrice>
              </ItemCard>
            ))}
          </ItemsGrid>
        </CatMainContent>
      </CatBody>
    </CatScreen>
  );
}

export default CategoriesScreen;
